import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { AvForm } from 'availity-reactstrap-validation';


import { Row, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

import CommodityModal from '../../components/Common/iComponents/iCommodityModal/ICommodityModal';
import SteeperHeaderSH from '../../components/Common/SteeperHeaderSH/SteeperHeaderSH';
import ShowAttachments from '../../components/Common/ShowAttachments/ShowAttachments';
import MilestonesLifeEvent from './MilestonesLifeEvent';
import IshowHouses from '../../components/Common/iComponents/iShowHouses/IshowHouses';
import ShowDocuments from '../../components/Common/ShowDocuments/ShowDocuments';
import ShowInnoboDocuments from '../../components/Common/ShowInnoboDocuments/ShowInnoboDocuments';

const IForm = ({
  selectedRow,
  milestoneConfig,
  groupName,
  columsPop = 4
}: any) => {
  const [listVisibleInModalHeader, setlistVisibleInModalHeader] = useState([
    {},
  ]);
  const [listVisibleInModalBody, setlistVisibleInModalBody] = useState([{}]);
  const [listVisibleInModalTotal, setlistVisibleInModalTotal] = useState([{}]);

  const [listIsMilestones, setlistIsMilestones] = useState([{}]);

  const [isShipmentsDataViewList, setShipmentsDataViewList] = useState<boolean>(false);

  const [isCommodityListView, setIsCommodityListView] =
    useState<boolean>(false);
  const [tabPurchaseView, setTabPurchaseView] = useState<string>('1');

  useEffect(() => {
    if (groupName === 'ShipmentsDataViewList') setShipmentsDataViewList(true);
  }, [groupName]);


  useEffect(() => {
    if (milestoneConfig) {

      const modalBody = milestoneConfig.filter(
        (x: { visibleInModalBody: boolean }) => x.visibleInModalBody === true,
      );

      const modalHeader = milestoneConfig.filter(
        (x: { visibleInModalHeader: boolean }) =>
          x.visibleInModalHeader === true,
      );
      const modalTotal = milestoneConfig.filter(
        (x: { visibleInModalTotal: boolean }) => x.visibleInModalTotal === true,
      );
      const isMilestone = milestoneConfig.filter(
        (x: { isMilestone: boolean }) => x.isMilestone === true,
      );

      setlistVisibleInModalBody(processList(modalBody, selectedRow));
      setlistVisibleInModalHeader(processList(modalHeader, selectedRow));
      setlistVisibleInModalTotal(processList(modalTotal, selectedRow));
      setlistIsMilestones(processList(isMilestone, selectedRow));
    }
  }, [milestoneConfig]);

  const getUrlValue = (value: any) => {
    const url = value?.toString()?.match(/https?:\/\/[^\s]+/g)
    let name: string | undefined = undefined;
    if (url) {
      name = value?.toString().split("-")[0]
    }
    return { url, name }
  }

  const processList = (list: any[], selectedRow: any) => {
    const t: any[] = [];
    for (const item in selectedRow) {
      list.map(function (data: { dataField: string }, index: any) {
        if (data.dataField === item)
          t.push({
            ...data,
            value: selectedRow[item],
          });
        return data;
      });
    }

    return t;
  };

  const renderModalHeader = () => {
    return (
      <React.Fragment>
        {listVisibleInModalHeader.length
          ? listVisibleInModalHeader.map((item: any, key: any) => {
            const { text, value } = item;
            const { url, name } = getUrlValue(value);
            if (value != '' && value != null) {
              return (
                <div key={key}>
                  <label className="labelModalHeader"> {text} </label>
                  <label
                    {...(url ? { onClick: (() => window.open(url[0], '_blank')) } : {})}
                    {...(url ? { style: { color: "blue" } } : {})}
                    className={`${url ? "cursor-pointer text-primary text-decoration-underline labelInfoModal" : "labelInfoModalHeader"}`}>
                    {name ?? value}
                  </label>
                </div>
              );
            }
          })
          : null}
      </React.Fragment>
    );
  };

  const renderInModalTotal = () => {
    return (
      <React.Fragment>
        {listVisibleInModalTotal.length
          ? listVisibleInModalTotal.map((item: any, key: any) => {
            const { text, value } = item;
            const { url, name } = getUrlValue(value);
            if (value != '' && value != null) {
              return (
                <div key={key}>
                  <label
                    {...(url ? { onClick: (() => window.open(url[0], '_blank')) } : {})}
                    className={`labelInfoModalTotal ${url ? "cursor-pointer text-primary text-decoration-underline" : ""}`}>
                    {' '}
                    {text} : {name ?? value}{' '}
                  </label>
                </div>
              );
            }
          })
          : null}
      </React.Fragment>
    );
  };
  const renderHeaderSteeper = () => {
    return (
      <div style={{ height: "17%" }}>
        <SteeperHeaderSH title='Shipment Progress' data={selectedRow} />
      </div>
    )
  }



  const renderInModalBody = () => {
    return (
      <React.Fragment>
        {listVisibleInModalBody.length
          ? listVisibleInModalBody.map((item: any, key: any) => {
            const { text, value } = item;
            const { url, name } = getUrlValue(value)
            if (value != '' && value != null) {
              return (
                <div key={key}>
                  <label className="labelModalBody"> {text} </label>
                  <label
                    {...(url ? { onClick: (() => window.open(url[0], '_blank')) } : {})}
                    {...(url ? { style: { color: "lightblue" } } : {})}
                    className={`${url ? "cursor-pointer text-primary text-decoration-underline labelInfoModal" : "labelInfoModalBody"}`}>
                    {name ?? value}
                  </label>
                </div>
              );
            }
          })
          : null}
      </React.Fragment>
    );
  };

  return (
    <>
      <div className="formContainer" style={{width: '100%'}}>
        {isShipmentsDataViewList ? (
          <div style={{ width: '100%' }}>
            <Nav horizontal="end" tabs>
              <NavItem>
                <NavLink
                  className={`${tabPurchaseView === '1' ? 'active' : ''} btn`}
                  onClick={() => setTabPurchaseView('1')}
                >
                  <i className="bi bi-info-circle pe-1"></i> Info
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink className={`${tabPurchaseView === '2' ? 'active' : ''} btn`} onClick={() => setTabPurchaseView('2')}>
                    <i className="bi bi-info-circle pe-1"></i> Commodities
                </NavLink>
              </NavItem>
               {
                  selectedRow.LayoutType === 'Master' && (
                    <NavItem>
                      <NavLink
                      className={`${tabPurchaseView === '3' ? 'active' : ''} btn`}
                      onClick={() => setTabPurchaseView('3')}
                      >
                      <i className="bx bx-align-middle"></i> Houses
                      </NavLink>  
                    </NavItem>
                  )
               }
              <NavItem>
                <NavLink
                  className={`${tabPurchaseView === '4' ? 'active' : ''} btn`}
                  onClick={() => setTabPurchaseView('4')}
                >
                  <i className="bx bx-file-blank"></i> Attachments
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={`${tabPurchaseView === '5' ? 'active' : ''} btn`}
                  onClick={() => setTabPurchaseView('5')}
                >
                  <i className="dripicons-document"></i> Documents
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className={`${tabPurchaseView === '6' ? 'active' : ''} btn`}
                  onClick={() => setTabPurchaseView('6')}
                >
                  <i className="dripicons-document"></i> My files
                </NavLink>
              </NavItem>

            </Nav>
            <TabContent activeTab={tabPurchaseView}>
              <TabPane tabId="1">
                {renderHeaderSteeper()}
                <Row className="upRown modalHeaderBackground">
                  <AvForm
                    className="custom-form mt-0"
                    style={{
                      display: 'grid',
                      gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
                      gridAutoRows: 'minmax(10%, 60px)',
                      gridGap: '2%',
                      padding: '0',
                      textAlign: 'center',
                    }}
                  >
                    {listVisibleInModalHeader.length
                      ? renderModalHeader()
                      : null}
                  </AvForm>
                </Row>
                <Row className="MiddleRown isMilestoneBackground">
                  {/*   //OLD Milestones  <BasicPills data={listIsMilestones} /> */}
                  <MilestonesLifeEvent selectedRow={selectedRow} />
                </Row>
                <Row className="DownRown modalBodyBackground">
                  <AvForm
                    className="custom-form mt-0"
                    style={{
                      display: 'grid',
                      gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
                      gridAutoRows: 'minmax(10%, 50px)',
                      gridGap: '2%',
                      padding: '0',
                    }}
                  >
                    {listVisibleInModalBody.length ? renderInModalBody() : null}
                  </AvForm>
                </Row>
                <Row
                  className="modalTotalBackground"
                  style={{
                    padding: '0',
                    textAlign: 'center',
                  }}
                >
                  {listVisibleInModalTotal.length ? renderInModalTotal() : null}
                </Row>
              </TabPane>

              <TabPane tabId="2">
                <Row className="cursor-pointer">
                  {!isCommodityListView &&  tabPurchaseView == "2" ? <CommodityModal visiblePackingList={false} SelectGuid={selectedRow} groupName={groupName}></CommodityModal> : null}
                </Row>
              </TabPane>



              <TabPane tabId="3">
                <IshowHouses
                  GUID={selectedRow.GUID}
                  Number={selectedRow.Number}
                />
              </TabPane>
              <TabPane tabId="4">
                <ShowAttachments
                  GUID={selectedRow.GUID}
                  type={'SH'}
                  Number={selectedRow.Number}
                  LayoutType={selectedRow.LayoutType}
                />
              </TabPane>
              <TabPane tabId="5">
                <ShowDocuments
                  GUID={selectedRow.GUID}
                  type={'SH'}
                  Number={selectedRow.Number}
                />
              </TabPane>

              <TabPane tabId="6">
                <ShowInnoboDocuments
                  GUID={selectedRow.GUID}
                  type={'SH'}
                  Number={selectedRow.Number}
                />
              </TabPane>
            </TabContent>
          </div>
        ) : null
        }
      </div>
    </>
  );
};

IForm.propTypes = {
  selectedRow: PropTypes.shape({
    Number: PropTypes.string,
    SellerName: PropTypes.string,
  }),
  milestoneConfig: PropTypes.shape({
    Number: PropTypes.string,
    SellerName: PropTypes.string,
    OperationName: PropTypes.string,
    OperationType: PropTypes.string,
    dataField: PropTypes.string,
    isMilestone: PropTypes.bool,
    order: PropTypes.string,
    text: PropTypes.string,
    userId: PropTypes.string,
    visibleInMiddle: PropTypes.bool,
    visibleInModalFooter: PropTypes.bool,
    visibleInModalHeader: PropTypes.bool,
    visibleInTable: PropTypes.bool,
    hidden: PropTypes.bool,
    visibleInModalBody: PropTypes.bool,
    visibleInModalTotal: PropTypes.bool,
  }),
  groupName: PropTypes.string,
  onCreate: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  columsPop: PropTypes.number
};

type Operations = {
  id?: number;
  Number?: string;
};

export default IForm;
